import { render, staticRenderFns } from "./index.vue?vue&type=template&id=683db306&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=683db306&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../1013/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683db306",
  null
  
)

export default component.exports